import { render, staticRenderFns } from "./UserFolder.vue?vue&type=template&id=4a75b2bc&scoped=true&"
import script from "./UserFolder.vue?vue&type=script&lang=js&"
export * from "./UserFolder.vue?vue&type=script&lang=js&"
import style0 from "./UserFolder.vue?vue&type=style&index=0&id=4a75b2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a75b2bc",
  null
  
)

/* custom blocks */
import block0 from "./UserFolder.vue?vue&type=custom&index=0&blockType=i18nf"
if (typeof block0 === 'function') block0(component)

export default component.exports